import { BottomSheet } from "@rneui/base";
import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "./text";
import Button from "./button";
import translate from "../libs/locale";
import variables from "src/merchant/assets/variables";
import TextInput from "./textInput";
import { getButtonModalWidth } from "../libs/utils/dimensions";
import { TABLET_PC } from "../libs/utils/constants";

const FulfillOrder = ({
  onClose,
  open,
  title,
  message,
  onPositive,
  buttonColor = variables.$brandColor,
  positiveText,
  onTextChange = null,
  disabled = false,
}) => {
  return (
    <BottomSheet
      modalProps={{ animationType: "fade" }}
      isVisible={open}
      onBackdropPress={onClose}
      scrollViewProps={{ keyboardShouldPersistTaps: "always" }}
    >
      <View style={[styles.root, TABLET_PC && styles.tabletContainer]}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.message}>{message}</Text>
        {onTextChange && (
          <View style={styles.remarkContainer}>
            <TextInput
              style={styles.remark}
              multiline
              placeholder={translate("remarkRejectOrder")}
              placeholderTextColor={variables.$disabledButton}
              onChangeText={onTextChange}
            />
          </View>
        )}
        <View style={styles.buttonContainer}>
          <Button
            disabled={disabled}
            text={positiveText.toUpperCase()}
            onPress={onPositive}
            style={[styles.fulfill, { backgroundColor: buttonColor }]}
            textStyle={styles.fulfillText}
            buttonColor={buttonColor}
          />
          <Button
            text={translate("cancel").toUpperCase()}
            onPress={onClose}
            style={[styles.fulfill, styles.cancelContainer]}
            textStyle={[styles.fulfillText, styles.cancel]}
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  root: {
    borderTopEndRadius: 20,
    borderTopStartRadius: 20,
    backgroundColor: "#FFFEF6",
    padding: 30,
  },
  tabletContainer: {
    alignSelf: "center",
    width: getButtonModalWidth(0.5),
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    overflow: "hidden",
  },
  buttonContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 29,
    marginHorizontal: 17,
  },
  title: {
    color: "#364650",
    fontSize: 20,
    fontFamily: "MontserratBold",
    alignSelf: "center",
    lineHeight: 35,
  },
  message: {
    color: "#364650",
    fontSize: 16,
    alignSelf: "center",
    textAlign: "center",
  },
  remarkContainer: {
    backgroundColor: "#ffff",
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginTop: 10,
    borderColor: variables.$disabledButton,
    height: 100,
  },
  remark: {
    color: "#364650",
    fontSize: 16,
    flex: 1,
  },
  fulfillText: {
    fontSize: 16,
    fontFamily: "MontserratBold",
  },
  fulfill: {
    flex: 1,
    marginLeft: 5,
    backgroundColor: variables.$brandColor,
    height: 50,
    borderRadius: 20,
  },
  cancel: {
    color: "#FFFEF6",
  },
  cancelContainer: {
    backgroundColor: "#ACB4B9",
    marginLeft: 20,
  },
});

export default FulfillOrder;
